import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/site/Header";
import Footer from "./components/site/Footer";
import SmoothScroll from "./components/site/SmoothScroll";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import DeleteAccount from "./pages/DeleteAccount";
import FleetDocumentExpiryReminder from "./pages/FleetDocumentExpiryReminder";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function CanonicalUrl() {
  const { pathname } = useLocation();
  useEffect(() => {
    const base = "https://renewtracker.site";
    const path = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
    const url = `${base}${path === "/" ? "" : path}` || base;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.setAttribute("content", url);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <CanonicalUrl />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/fleet-document-expiry-reminder" element={<FleetDocumentExpiryReminder />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
